export const tradeLabel = (id, trades) => {
  const ele = trades.filter(t => {
    return t.id == id || t.value == id;
  })[0];
  return ele ? ele.text || ele.label : id;
};
